import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const barChartTool: Tool = {
  id: "bar-chart",
  name: () => m.bar_tool_name(),
  description: () => m.bar_tool_description(),
  icon: "📊",
  basePath: "/bar-chart",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "bar-chart", "science"],
};
